import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
// import startup from '../../public/img/startup.png'

const styles = theme => ({
  card: {
    // maxWidth: 345,
  },
  media: {
    objectFit: 'cover',
  },
  inputContainer: {
    backgroundColor: theme.palette.primary.main,
  },
  bootstrapInput: {
    borderRadius: '4px 0px 0px 4px',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    borderRight: '0px',
    fontSize: 16,
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderColor: '#80bdff',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  margin: {
    width: '100%',
  },
  inputBase: {
    width: '100%',
    marginTop: theme.spacing.unit - 3,
  },
  avatar: {
    width: '50px',
    height: '50px',
    float: 'right',
  },
  avatarMargin: {
    textAlign: 'right',
    marginTop: -theme.spacing.unit * 6 - 2,
  },
  BoostList: {
    marginBottom: theme.spacing.unit + 2,
  },
  resize: {
    fontSize: '14px',
  },
  avatar_mul: {
    width: '30px',
    height: '30px',
    margin: theme.spacing.unit - 3,
    backgroundColor: '#80808070',
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'row',
  },
  sendButton: {
    width: '120px',
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    marginLeft: '10px',
    marginTop: theme.spacing.unit,
    boxShadow: 'none',
    display: 'inline',
  },
  button: {
    width: '120px',
    marginTop: theme.spacing.unit,
    boxShadow: 'none',
    display: 'inline',
  },
  textField: {
    backgroundColor: '#fff',
  },
  startup: {
    height: '41px',
    backgroundColor: '#fff',
    border: '1px solid #ced4da',
    borderLeft: '0px',
  },
  inputBox: {
    display: 'flex',
    justifyContent: 'center',
    align: 'center',
  },
});

const Comments = props => {
  const { classes, data } = props;
  const { owner } = data;
  let ownerName = owner.firstName + ' ' + owner.lastName;
  return (
    <CardActionArea className={classes.BoostList}>
      <CardContent>
        <div>
          <span>
            <Typography component="p">
              {ownerName} | {owner.location}
            </Typography>
            <hr />
            <Typography component="p">
              <i>{data.content}</i>
            </Typography>
            <div className={classes.avatarMargin}>
              <Avatar
                className={classes.avatar}
                alt={ownerName}
                src={owner.profilePic}
              />
            </div>
          </span>
        </div>
      </CardContent>
    </CardActionArea>
  );
};

class BoostCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      commentMode: false,
    };
  }

  focus = e => {
    this.setState({ commentMode: true });
  };
  cancel = e => {
    this.setState({ commentMode: false });
  };
  send = e => {
    this.setState({ commentMode: false });
  };
  expand = () => {
    this.setState({ expanded: true });
  };
  minimize = () => {
    this.setState({ expanded: false });
  };

  render() {
    const { classes, comments = [] } = this.props;
    let remainingCount = '';
    if (comments.length > 2) {
      remainingCount = <span onClick={this.expand}>MORE...</span>;
    }
    let moreComments = [];
    if (this.state.expanded === true && comments.length > 2) {
      for (var i = 2; i < comments.length; i++) {
        moreComments.push(
          <Comments key={'tip' + i} classes={classes} data={comments[i]} />
        );
      }
      remainingCount = <span onClick={this.minimize}>LESS...</span>;
    }
    return (
      <div>
        <Card className={classes.card}>
          <CardContent>
            <Typography component="p" align="center">
              Our pages are started by one contributor and maintained by our
              expert community of contributors. Please explore their work and
              send them a message if you found this content useful.
            </Typography>
            <Typography component="h5" variant="subtitle1" align="center">
              We would love to hear from you!
            </Typography>
          </CardContent>

          <div className={classes.inputContainer}>
            <CardContent>
              {this.state.commentMode ? (
                <div>
                  <FormControl className={classes.margin}>
                    <TextField
                      id="outlined-multiline-flexible"
                      // label="Multiline"
                      multiline
                      placeholder="Type your comments to suggest any update!!"
                      rowsMax="2"
                      autoFocus={true}
                      // value={this.state.multiline}
                      // onChange={this.handleChange('multiline')}
                      className={classes.textField}
                      margin="normal"
                      // helperText="hello"
                      InputProps={{
                        classes: {
                          input: classes.resize,
                        },
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                  <div className={classes.avatarContainer}>
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                    <Avatar
                      className={classes.avatar_mul}
                      alt="Adelle Charles"
                      src=""
                    />
                  </div>
                  <FormControl className={classes.inputBase}>
                    <InputBase
                      id="bootstrap-input"
                      // defaultValue="react-bootstrap"
                      placeholder="Name"
                      classes={{
                        root: classes.bootstrapRoot,
                        input: classes.bootstrapInput,
                      }}
                    />
                  </FormControl>
                  <FormControl className={classes.inputBase}>
                    <InputBase
                      id="bootstrap-input"
                      // defaultValue="react-bootstrap"
                      placeholder="City"
                      classes={{
                        root: classes.bootstrapRoot,
                        input: classes.bootstrapInput,
                      }}
                    />
                  </FormControl>
                  <div align="right">
                    <Button
                      variant="contained"
                      onClick={this.cancel}
                      className={classes.button}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={this.send}
                      className={classes.sendButton}
                    >
                      Send
                    </Button>
                  </div>
                </div>
              ) : (
                <div className={classes.inputBox} onFocus={e => this.focus(e)}>
                  <FormControl className={classes.margin}>
                    <InputBase
                      id="bootstrap-input"
                      placeholder="Write to our Pundits!!"
                      classes={{
                        root: classes.bootstrapRoot,
                        input: classes.bootstrapInput,
                      }}
                    />
                  </FormControl>
                  <img
                    className={classes.startup}
                    src="/img/startup.png"
                    alt="startup"
                  />
                </div>
              )}
            </CardContent>
          </div>
          {/* TODO:
          <CardContent>
             temporary commented <Typography component="p" className={classes.typoMargin}>
              APPLAUSE RECIEVED!
            </Typography>
          </CardContent>*/}
          {comments.length > 0 ? (
            <Comments key={'tip0'} classes={classes} data={comments[0]} />
          ) : (
            ''
          )}
          {comments.length > 1 ? (
            <Comments key={'tip1'} classes={classes} data={comments[1]} />
          ) : (
            ''
          )}
          {moreComments}
          <CardContent>
            <Typography component="p">{remainingCount}</Typography>
          </CardContent>
        </Card>
      </div>
    );
  }
}

BoostCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BoostCard);
